class CartCount extends HTMLElement {
  constructor() {
    super();

    document.addEventListener("updateCart", (e) => {
      this.innerHTML = `
        <span aria-hidden="true">${e.detail.cart.item_count}</span>
        <span class="visually-hidden">
          ${e.detail.cart.item_count}
          Item${e.detail.cart.item_count === 1 ? "" : "s"}
        </span>`;

      this.style.display = e.detail.cart.item_count > 0 ? null : "none";
    });
  }
}

if (!customElements.get("cart-count")) {
  customElements.define("cart-count", CartCount);
}
